import { Center, Separator, VStack } from "@chakra-ui/react"
import { useCertificateContext } from "../context/CertificateContext"
import CertificateResources from "../manager/CertificateResources"
import CertificateResourceUpdatePrompt from "./CertificateResourceUpdatePrompt"
import CertificateUpdatePrompt from "./CertificateUpdatePrompt"

function CertificateResourcesManager() {
  const { resource } = useCertificateContext()
  return (
    <VStack gap={8} px={8} pb={8}>
      {resource ? (
        <CertificateResourceUpdatePrompt resource={resource} />
      ) : (
        <>
          <CertificateUpdatePrompt />
          <Center height="50px">
            <Separator
              orientation="horizontal"
              borderRightWidth={0}
              borderLeftWidth="1px"
              h="100%"
            />
          </Center>
          <CertificateResources />
        </>
      )}
    </VStack>
  )
}

export default CertificateResourcesManager
